import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import style from './index.module.scss';
import { PageVersionTypeEnums } from '../../types';

interface PageVersionUIConfig {
  logoImageUrl?: string;
  title?: string;
  buttonText?: string;
}

const componentUIConfigs: Partial<Record<PageVersionTypeEnums, PageVersionUIConfig>> = {
  [PageVersionTypeEnums.EVOKE_APP_MARKET_FINANCE_WX_MP]: {
    logoImageUrl: 'https://m.hellobike.com/resource/gallery/522/hLKKWq6a_hello-finance-logo@3x.png',
    title: '点击打开哈啰臻有钱微信小程序',
    buttonText: '立即打开',
  },
};

@Component({ name: 'simplePage' })
export default class SimplePage extends Vue {
  /** 营销页的版本 */
  @Prop(String) readonly pageVersion!: PageVersionTypeEnums

  private handleClickEvoke() {
    this.$emit('evokeApp');
  }

  private render() {
    const config = componentUIConfigs[this.pageVersion];

    if (config) {
      return (
        <div class={style.simplePage}>
          <div class={style.content} >
            <img class={style.logoImage} src={config.logoImageUrl} />
            <p class={style.title}>{config.title || ''}</p>
            <p class={style.button} onClick={() => this.handleClickEvoke()}>
              {config.buttonText}
            </p>
          </div>
        </div>
      );
    }

    return null;
  }
}
